// extracted by mini-css-extract-plugin
export default {"CollapsableArea":"CollapsableArea-module-b82e4e9c3693ae0d5b29","animated":"CollapsableArea-module-eae497187f35b1504e43"};